import React from 'react';

function GridIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g id="Grid">
        <path
          d="M2 2H14M2 6H14M2 10H14M2 14H14M2 2V14M6 2V14M10 2V14M14 2V14"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default GridIcon;
